export default "__VITE_PUBLIC_ASSET__a77a86d5__"